import React, { useEffect, useState, useTransition } from "react";
import Header from "../../Shared/Header";
import SideMenu from "../../Shared/SideMenu";
import { useDispatch, useSelector } from "react-redux";
import { fetchLanguageList, fetchSpecialtyList, fetchStateList, fetCountryList } from "../../Redux/actions/commonActions";
import { Avatar, Spin } from "antd";
import { FaUser } from "react-icons/fa";
import PatientSearch from "../../Shared/PatientSearch";
import { IoMdArrowDropup, IoMdClose } from "react-icons/io";
import { clearSelectedPatient, setSelectedPatient } from "../../Redux/actions/patientActions";
import users from "../../Assets/newicons/users.png";
import { fetchRpmPatientFilterCount } from "../../Redux/actions/rpmActions";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { APP_ROUTES } from "../../PageRouting/PageRoutes";
import { useNavigation } from "../../Context/NavigationContext";
import NavigationOverlay from "../../Shared/NavigationOverlay";

const Layouts = ({ children }) => {
  // const { isPending } = useNavigation();
  const [isMenuOpen, setMenuOpen] = useState(true);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("critical");
  const dispatch = useDispatch();
  const history = useHistory();
  const { rpmPatientFiltersCount } = useSelector((state) => state.rpm);
  const loggedUserObj = sessionStorage.getItem('login_result');
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;
  const selectedPatJson = sessionStorage.getItem('selectedPatient');
  const selectedPat = selectedPatJson ? JSON.parse(selectedPatJson):null;
  const membership = sessionStorage.getItem('membership');


  useEffect(() => {
    if (!loggedUser) {
      return;
    }
    if(selectedPat){
      dispatch(setSelectedPatient(selectedPat));
    }
    const payload = {
      status: 1
    }
    dispatch(fetCountryList(payload));
    dispatch(fetchStateList(payload));
    dispatch(fetchSpecialtyList(payload));
    dispatch(fetchLanguageList(payload));
    if (loggedUser?.user && loggedUser.user.rpmApplicable === 'Y') {
      const payload = {
        user_account_Id: loggedUser.user.account_Id,
        user_clinic_Id: loggedUser.user.clinic_Id,
        status: 1
      }
      dispatch(fetchRpmPatientFilterCount(payload));
    }
    
  }, [dispatch]);

  const handleSideBarMenu = () => {
    setMenuOpen(prevState => !prevState);
  }

  const toggleDrawer = () => {
    setIsDrawerOpen((prev) => !prev);
  };

  const handleSelectCategory = (category) => {
    setSelectedCategory(category);
    sessionStorage.setItem('category', category);
    if (category === 'critical') {
      history.push(APP_ROUTES.PATIENTCRITICAL, { data: category });
    }
    else if (category === 'abnormal') {
      history.push(APP_ROUTES.PATIENTABNORMAL, { data: category });
    }
    else if (category === 'normal') {
      history.push(APP_ROUTES.PATIENTNORMAL, { data: category });
    }


  }

  return (
    <div className="h-full flex flex-col bg-[#F1FFF9]">
      <Header handleSideBarMenu={handleSideBarMenu} />
      <div className="w-full flex gap-2">
        <div className={`${(isMenuOpen ? 'w-[13%]' : 'w-[3%]')} my-1`}>
          <SideMenu isMenuOpen={isMenuOpen} handleSideBarMenu={handleSideBarMenu} />
        </div>
        <div className={`${(isMenuOpen ? 'w-[86%]' : 'w-[96%]')}`}>
          {(loggedUser?.user && loggedUser.user.rpmApplicable === 'Y') && (<div
            className="critical"
            style={{ marginTop: "8rem" }}
            onClick={toggleDrawer}
          >
            <p className="critical-p">
              <div className="critical-icon-dashboard">
                <IoMdArrowDropup className="text-[#F46257] w-6 h-6" />
              </div>
            </p>
          </div>)}
          {
            isDrawerOpen && (
              <div className="fixed top-60 right-6 h-80 w-36 bg-white border-[#D3D3D3] border rounded-lg shadow-lg p-4 z-50">
                <div className="flex flex-col gap-3">
                  <div onClick={() => handleSelectCategory("critical")} className="flex flex-col items-center gap-2 cursor-pointer">
                    <div className="w-10 h-10 rounded-full bg-[#FF3022] flex items-center justify-center">
                      <img src={users} alt="" className="w-6 h-6" />
                    </div>
                    <label className="text-xs font-sans font-medium">Critical Patients</label>
                    <p className="text-xs font-inter font-medium">{rpmPatientFiltersCount?.Total_Critical_Patient_Count || 0}</p>
                  </div>
                  <div onClick={() => handleSelectCategory("abnormal")} className="flex flex-col items-center gap-2 cursor-pointer">
                    <div className="w-10 h-10 rounded-full bg-[#00B24B] flex items-center justify-center">
                      <img src={users} alt="" className="w-6 h-6" />
                    </div>
                    <label className="text-xs font-sans font-medium">Abnormal Patients</label>
                    <p className="text-xs font-inter font-medium">{rpmPatientFiltersCount?.Total_Abnormal_Patient_Count || 0}</p>
                  </div>
                  <div onClick={() => handleSelectCategory("normal")} className="flex flex-col items-center gap-2 cursor-pointer">
                    <div className="w-10 h-10 rounded-full bg-[#FFA12C] flex items-center justify-center">
                      <img src={users} alt="" className="w-6 h-6" />
                    </div>
                    <label className="text-xs font-sans font-medium">Normal Patients</label>
                    <p className="text-xs font-inter font-medium">{rpmPatientFiltersCount?.Total_Normal_Patient_Count || 0}</p>
                  </div>
                </div>
              </div>
            )}
          <div className=" relative h-screen bg-white my-1 py-1 overflow-auto border rounded-lg scrollHide">
            {/* {isPending && (
              <div className="absolute inset-0 z-50 flex items-center justify-center bg-white/60 backdrop-blur-sm">
                <Spin size="large" />
              </div>
            )} */}
            <NavigationOverlay /> 
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layouts;
// bg-[#20638e]
// bg-[#f6f6f6]

